import {
	useDecisionMakerProfilePageData,
	useDMProfilePagePaginatedTargetedPetitionsData,
} from 'src/app/pages/decisionMakerProfile/pageContext';
import { useMultipleQueryParamsValue } from 'src/app/shared/hooks/location';
import { useTrackView } from 'src/app/shared/hooks/tracking';

import { useResponsivenessScoreEnabled } from '../useResponsivenessScoreEnabled';
import { useTrackDmrlView } from '../useTrackDmrlView';

type Result = ModelHookResult<{
	dmReputationLayer: {
		isDmrlEnabled: boolean;
		hasCampaignPhotoOrWebsites: boolean;
		hasEndorsements: boolean;
		hasDmrlData: boolean;
	};
}>;

export function useLayout(): Result {
	const [sourceLocation, showDmrl] = useMultipleQueryParamsValue(['source_location', 'showDmrl']);
	const {
		data: {
			id,
			type,
			verifiedAt,
			enrichedData,
			featureConfigs: { dmReputationLayer },
		},
	} = useDecisionMakerProfilePageData();

	const {
		data: { totalCount: petitionCount },
	} = useDMProfilePagePaginatedTargetedPetitionsData();

	const responsivenessScoreEnabled = useResponsivenessScoreEnabled();

	const isDmrlEnabled = dmReputationLayer.enabled || showDmrl === 'true';

	useTrackView(
		'dm_show_view',
		{
			dm_id: `dm_${id}`,
			dm_verified: !!verifiedAt,
			dm_type: type,
			dm_petitions_num: petitionCount,
			source_location: sourceLocation,
			dm_responsiveness_score_enabled: responsivenessScoreEnabled,
		},
		[],
	);

	useTrackDmrlView({ isDmrlEnabled, decisionMakerId: id });

	const hasCampaignPhoto = !!enrichedData?.campaignPhotoUrl;
	const hasWebsitesData = (enrichedData?.websites ?? []).length > 0;
	const hasEndorsements = !!enrichedData?.endorsementsOverview;
	const hasCampaignPhotoOrWebsites = hasCampaignPhoto || hasWebsitesData;

	const hasDmrlData = enrichedData !== null;

	return {
		data: {
			dmReputationLayer: {
				isDmrlEnabled,
				hasCampaignPhotoOrWebsites,
				hasEndorsements,
				hasDmrlData,
			},
		},
	};
}
